import React, {useEffect} from 'react';
import { withStyles } from "@mui/styles";
import LoadingCircle from "../../../util/common/LoadingCircle";
import SingleQuestionPage from "./multiple-choice/one-dimension/SingleQuestionPage";
import MultipleChoiceSurvey from "./common/MultipleChoiceSurvey";
import MultipleChoiceResults from "./common/results/MultipleChoiceResults";
import TwoDimension2QuestionPage from "./multiple-choice/two-dimension/TwoDimension2QuestionPage";

const styles = {
  root: {
    display: "flex",
    justifyContent: "space-around",
    width: "100%",
    margin: "0 0 0.5rem 0.5rem",
    overflow: "hidden"
  },
  body: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },
}

function SurveyView(props) {
  const { classes, ...passProps } = props;
  const { attemptId, surveyAttempt, loadSurvey } = passProps;

  const loading = !surveyAttempt || !surveyAttempt.survey?.options || (!!surveyAttempt.id && surveyAttempt.id !== attemptId);

  useEffect(() => {
    if(loading) {
      loadSurvey()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const body =
    loading || !surveyAttempt.survey?.survey_type ? <LoadingCircle />
    : surveyAttempt.survey.survey_type === "multiple-choice-2d" ?
        <MultipleChoiceSurvey
          {...passProps}
          QuestionPage={TwoDimension2QuestionPage}
          ResultsPage={MultipleChoiceResults}
        />
        // <TwoDimensionSurvey {...passProps} />
    : surveyAttempt.survey.survey_type === "multiple-choice-1d" ?
        <MultipleChoiceSurvey
          {...passProps}
          QuestionPage={SingleQuestionPage}
          ResultsPage={MultipleChoiceResults}
        />
    : <MultipleChoiceSurvey
        {...passProps}
        QuestionPage={SingleQuestionPage}
        ResultsPage={MultipleChoiceResults}
      />;


  return(
    <div className={classes.root}>
      <div className={classes.body}>
        {body}
      </div>
    </div>
  );
}

export default withStyles(styles)(SurveyView);
